import { useEffect, useRef, useState } from 'react'

export const useMinutesSecondsTimer = (
  minutes = 0,
  seconds = 30,
  shouldStart = false,
  onExpire = () => {}
) => {
  const totalInitialSeconds = minutes * 60 + seconds
  const [timeLeft, setTimeLeft] = useState(totalInitialSeconds)
  const intervalRef = useRef(null)

  useEffect(() => {
    if (shouldStart && timeLeft > 0) {
      intervalRef.current = setInterval(() => {
        setTimeLeft(prevTime => {
          if (prevTime <= 1) {
            clearInterval(intervalRef.current)
            onExpire()
            return 0
          }
          return prevTime - 1
        })
      }, 1000)
    }

    return () => clearInterval(intervalRef.current)
  }, [shouldStart, timeLeft, onExpire])

  const resetTimer = () => {
    clearInterval(intervalRef.current)
    setTimeLeft(totalInitialSeconds)
  }

  const formattedTime = {
    minutes: Math.floor(timeLeft / 60),
    seconds: timeLeft % 60 < 10 ? `0${timeLeft % 60}` : timeLeft % 60,
  }

  return { timeLeft, formattedTime, resetTimer }
}
